import type { Property, PropertyStatus } from './property-types'

export type PropertyStatusFilter = 'all' | PropertyStatus

export function filterProperties(
  properties: Property[],
  search: string,
  status: PropertyStatusFilter,
): Property[] {
  const normalizedSearch = search.trim().toLocaleLowerCase()
  return properties.filter((property) => {
    const matchesStatus = status === 'all' || property.status === status
    const searchableText = [property.name, property.address_line_1, property.city, property.region, property.postal_code]
      .join(' ')
      .toLocaleLowerCase()
    return matchesStatus && (!normalizedSearch || searchableText.includes(normalizedSearch))
  })
}
